import React from 'react';
import styled from 'styled-components';

export const BackToTop = ({ scrollContainerRef }) => {
  const [scrolled, setScrolled] = React.useState(false);
  const scrollContainer = React.useMemo(
    () => (scrollContainerRef ? scrollContainerRef.current : window),
    [scrollContainerRef?.current]
  );

  const handleScroll = () => {
    const isTop = scrollContainer.scrollTop < 150;
    setScrolled(!isTop);
  };

  React.useEffect(() => {
    if (scrollContainer) {
      scrollContainer.addEventListener('scroll', handleScroll);
      return () => scrollContainer.removeEventListener('scroll', handleScroll);
    }
  }, [scrollContainer]);

  const handleScrollToTop = () => {
    if (scrollContainer) {
      scrollContainer.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
  };

  return (
    scrolled && (
      <Button onClick={handleScrollToTop} title="Back to top">
        <Icon />
      </Button>
    )
  );
};

const Button = styled.button`
  position: fixed;
  bottom: 20px;
  right: 30px;
  z-index: 99;
  cursor: pointer;
  background-color: ${({ theme, bg = 'primary' }) => theme.colors[bg] || bg};
  color: ${({ color = '#fff' }) => color};
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  transform: rotate(-90deg);
  border: none;
  border-radius: 50%;
  box-shadow: 0px 1px 6px rgb(0 0 0 / 16%);
  opacity: 1;
  transition: opacity 300ms ease-in-out;
  &:hover {
    opacity: 0.9;
  }
`;

const Icon = () => (
  <svg
    fill="currentColor"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z" />
    <path d="M0-.25h24v24H0z" fill="none" />
  </svg>
);
